import { render, staticRenderFns } from "./telzxdet.vue?vue&type=template&id=a3c27436&scoped=true&"
import script from "./telzxdet.vue?vue&type=script&lang=js&"
export * from "./telzxdet.vue?vue&type=script&lang=js&"
import style0 from "./telzxdet.vue?vue&type=style&index=0&id=a3c27436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c27436",
  null
  
)

export default component.exports